import { hashHistory} from 'react-router';
import { isPluginMode } from "../../utils/isPluginMode";

export function getQueryParamValue(paramValue) {
  const paramObject = {};
  const params = isPluginMode () ? hashHistory.getCurrentLocation().search.slice(1).split('&') : window.location.search.slice(1).split('&');
  params.forEach((param) => {
    const [key, value] = param.split('=');
    paramObject[key] = value;
  });
  return paramObject[paramValue];
}
